export const WIDGET_PANEL_CLASS =
  'rounded-lg border border-border bg-card text-card-foreground shadow-sm';

export const WIDGET_SUBTLE_PANEL_CLASS =
  'rounded-lg border border-border bg-muted/40 text-card-foreground';

export const WIDGET_MUTED_TEXT_CLASS = 'text-muted-foreground';

export const WIDGET_ALERT_INFO_CLASS =
  'rounded-lg border border-primary/40 bg-primary/10';
export const WIDGET_ALERT_SUCCESS_CLASS =
  'rounded-lg border border-chart-2/40 bg-chart-2/10';
export const WIDGET_ALERT_WARNING_CLASS =
  'rounded-lg border border-chart-5/40 bg-chart-5/10';
export const WIDGET_ALERT_DANGER_CLASS =
  'rounded-lg border border-destructive/40 bg-destructive/10';
export const WIDGET_ALERT_PURPLE_CLASS =
  'rounded-lg border border-chart-4/40 bg-chart-4/10';

export const WIDGET_ALERT_INFO_TEXT_CLASS = 'text-primary';
export const WIDGET_ALERT_SUCCESS_TEXT_CLASS = 'text-chart-2';
export const WIDGET_ALERT_WARNING_TEXT_CLASS = 'text-chart-5';
export const WIDGET_ALERT_DANGER_TEXT_CLASS = 'text-destructive';
export const WIDGET_ALERT_PURPLE_TEXT_CLASS = 'text-chart-4';

export const WIDGET_STATUS_BADGE_INFO_CLASS =
  'border-primary/40 bg-primary/10 text-primary';
export const WIDGET_STATUS_BADGE_SUCCESS_CLASS =
  'border-chart-2/40 bg-chart-2/10 text-chart-2';
export const WIDGET_STATUS_BADGE_WARNING_CLASS =
  'border-chart-5/40 bg-chart-5/10 text-chart-5';
export const WIDGET_STATUS_BADGE_DANGER_CLASS =
  'border-destructive/40 bg-destructive/10 text-destructive';
export const WIDGET_STATUS_BADGE_PURPLE_CLASS =
  'border-chart-4/40 bg-chart-4/10 text-chart-4';

export const RETRO_SUCCESS_SECTION_CLASS =
  'rounded-lg border border-chart-2/40 bg-chart-2/10 p-4';
export const RETRO_RISK_SECTION_CLASS =
  'rounded-lg border border-destructive/40 bg-destructive/10 p-4';
export const RETRO_WARNING_SECTION_CLASS =
  'rounded-lg border border-chart-5/40 bg-chart-5/10 p-4';
export const RETRO_INFO_SECTION_CLASS =
  'rounded-lg border border-primary/40 bg-primary/10 p-4';

export const RETRO_SUCCESS_ICON_CLASS = 'text-chart-2';
export const RETRO_RISK_ICON_CLASS = 'text-destructive';
export const RETRO_WARNING_ICON_CLASS = 'text-chart-5';
export const RETRO_INFO_ICON_CLASS = 'text-primary';